<div class="vertical-center-flex">
  <div class="login-container center-block">
    <div class="boxshadow">
      <div class="panel-body-left panel-body-white">
        <div class="panel-title">Zmiana hasła</div>
        <div class="panel-description">
          Wprowadź nowe hasło, minimum 6 znaków:
        </div>
        <form class="login" name="loginForm" #f="ngForm" novalidate
          (ngSubmit)="changePass()">

          <div class="form-group-row">
            <div class="form-group has-feedback input-group">
              <img src="/images/icons/haslo.png" />
              <div class="field-input" [ngClass]="{'has-success': f.submitted && password.valid, 'has-error' : f.submitted && !password.valid}">
                <input type="password" id="login-password" name="password" placeholder="hasło" class="form-control" [(ngModel)]="model.newPassword" #password="ngModel" required />
                @if (f.submitted) {
                  <span class="glyphicon form-control-feedback" [ngClass]="{'glyphicon-ok ': password.valid, 'glyphicon-remove' : !password.valid}" aria-hidden="true"></span>
                }

              </div>
            </div>
          </div>
          @if (f.submitted && !password.valid) {
            <span class="errorMessage">
              Hasło jest wymagane
            </span>
          }
          @if (!loggedIn) {
            <div class="form-group-row">
              <div class="action-redirect" (click)="signIn()">Zaloguj się</div>
            </div>
          }

          <div class="form-group-row">
            <div class="form-group">
              <button id="login-button" mat-flat-button
                style="text-align:center;"
                type="submit" class="btn btn-primary next-step-button" [disabled]="isLoading">
                @if (isLoading) {
                  <i class='fa fa-circle-o-notch fa-spin'></i>
                }
                <img src="/images/icons/zaloguj.png"
                  style="margin-top: 5px;position: inherit;margin-right: 11px;margin-left: 0px;" />
                <span>
                  {{isLoading ? 'Logowanie ...' : 'USTAW'}}
                </span>
              </button>
            </div>
          </div>
          @if (!loggedIn) {
            <div class="form-group-row">
              <div class="action-register" (click)="signUp()">Zarejestruj się</div>
            </div>
          }
          @if (loggedIn) {
            <div class="form-group-row">
              <div class="action-redirect" (click)="removeAccountDialog()">Usuń konto</div>
            </div>
          }
        </form>
      </div>

      <div class="panel-body-right panel-body-livegreen">

        <div class="panel-title">Witaj!</div>
        <div class="panel-description">
          Uzupełnij podstawowe dane aby móc w pełni skorzystać z możliwości aplikacji.
          Dostęp na dowolnym urządzeniu i zapisywanie historii projektów.
        </div>
        @if (!loggedIn) {
          <div class="form-group-row">
            <div class="form-group">
              <button id="login-button" mat-flat-button
                style="text-align:center;"
                type="submit" class="btn btn-primary white-button" [disabled]="isLoading"
                (click)="signUp()">
                @if (isLoading) {
                  <i class='fa fa-circle-o-notch fa-spin'></i>
                }
                <img src="/images/icons/zaloz konto-livegreen.png" style="margin-top: 5px;position: inherit;margin-right: 11px;margin-left: 0px;" />
                <span>
                  ZAŁÓŻ KONTO
                </span>
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
